import { addBreadcrumb, captureError } from '@sazeo/observability';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    addBreadcrumb({ action: 'react_component_crash', componentStack: info.componentStack });
    captureError(error, { type: 'react_component_error', componentStack: info.componentStack });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          className="flex min-h-screen items-center justify-center bg-[var(--color-bg)] p-8 text-center font-sans text-[14px] text-[var(--color-text-secondary)]"
        >
          დაფიქსირდა შეცდომა. ინფორმაცია უკვე გაიგზავნა ტექნიკურ გუნდთან.
        </div>
      );
    }
    return this.props.children;
  }
}
